import React, { useState } from "react";
import HelloText from "../components/HelloText";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button, StepContext } from "@mui/material";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
const HealtUpdate = () => {
    let params = useParams();
    console.log(params.id);
    const { data, error } = useSWR(
        process.env.REACT_APP_DEF_URL + "post?link=" + params.id
      );
      const [link, setLink] = useState();
      const [name, setName] = useState();
      const [language, setLanguage] = useState();
      const [Image, setImage] = useState();
      const [text, setText] = useState()
      const [tag, setTag] = useState()
      const [description, setDescription] = useState()
      const [title, setTitle] = useState()
      const [metaTitle, setmetaTitle] = useState();
      const [metDescription, setmetDescription] = useState();
      const [schema, setschema] = useState();
      const [schema2, setschema2] = useState();
      const avatarHandle = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.addEventListener("load", function () {
          setImage(this.result);
        });
        reader.readAsDataURL(file);
      };
      const [open, setOpen] = React.useState(false);
      const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
      };
      const API_URL = "https://api.metincevener.com/img"
      const UPLOAD_ENDPOINT = "ckup/ckup"
      function uploadAdapter(loader) {
        return {
          upload: () => {
            return new Promise((resolve, reject) => {
              const body = new FormData();
              loader.file.then((file) => {
                body.append("uploadImg", file);
                // let headers = new Headers();
                // headers.append("Origin", "http://localhost:3000");
                fetch(`${API_URL}/${UPLOAD_ENDPOINT}`, {
                  method: "post",
                  body: body
                  // mode: "no-cors"
                })
                  .then((res) => res.json())
                  .then((res) => {
                    resolve({
                      default: `${API_URL}/${res.filename}`
                    });
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
            });
          }
        };
      }
      function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
          return uploadAdapter(loader);
        };
      }
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <>
      <HelloText />
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "healthupdate.php"}
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
        autoComplete="off"
        encType="multipart/form-data"
      >
        <TextField
          id="outlined-basics"
          label="Link"
          variant={"outlined"}
          fullWidth
          name="health_link"
          onChange={(e) => setLink(e.target.value)}
          value={link}
          defaultValue={data.health_link}
        />
        <TextField
          id="outlined-basics"
          label="Başlık"
          variant={"outlined"}
          fullWidth
          name="health_title"
          onChange={(e) => setTitle(e.target.value)}
          value={title}
          defaultValue={data.health_title}
        />
        <TextField
          id="outlined-basics"
          label="description"
          variant={"outlined"}
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          name="health_description"
          onChange={(e) => setDescription(e.target.value)}
          defaultValue={data.health_description}
          value={description}
        />

        <div className="editor">
          <CKEditor
            editor={ClassicEditor}
            data={data.health_text}
            config={{
              extraPlugins : [uploadPlugin],
              mediaEmbed: {
                previewsInData: true,
              }
            }}
            onReady={(editor) => {
              // You can store the "editor" and use when it is needed.
              console.log("Editor is ready to use!", editor);
              setText(data.health_text)
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              console.log({ event, editor, data });
              setText(data)
            }}
            onBlur={(event, editor) => {
              console.log("Blur.", editor);
            }}
            onFocus={(event, editor) => {
              console.log("Focus.", editor);
            }}
          />
        </div>
            <input type="text" name="health_text" value={text} />
            <input type="text" name="health_id" value={data.health_id} />
        <label for="lang">Dil:</label>
        <select
          name="health_lang"
          id="lang"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="tr-TR">tr</option>
          <option value="en-gb">en</option>
        </select>
        {Image ? (
          <img
            id="blah"
            src={Image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        ) : (
          <img
            id="blah"
            src={data.health_image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        )}
        <Button variant="contained" component="label">
        Resim yükle
        <input
          hidden
          accept="image/*"
          multiple
          type="file"
          name="health_image"
          onChange={avatarHandle}
        />
      </Button>
      <p>Meta Alanı</p>
        <TextField
          id="outlined-basics"
          label="tags"
          variant={"outlined"}
          fullWidth
          name="health_keywords"
          onChange={(e) => setTag(e.target.value)}
          value={tag}
          defaultValue={data.health_keywords}
        />

        <TextField
          id="outlined-basics"
          label="Meta Title"
          variant={"outlined"}
          fullWidth
          name="meta_title"
          onChange={(e) => setmetaTitle(e.target.value)}
          value={metaTitle}
          defaultValue={data.meta_title}
          
        />
         <TextField
          id="outlined-basics"
          label="Meta Description"
          variant={"outlined"}
          fullWidth
          name="meta_description"
          onChange={(e) => setmetDescription(e.target.value)}
          value={metDescription}
          defaultValue={data.meta_description}
          multiline
          minRows={3}
          maxRows={8}
        />
        <TextField
          id="outlined-basics"
          label="Schema"
          variant={"outlined"}
          fullWidth
          name="meta_schema"
          onChange={(e) => setschema(e.target.value)}
          value={schema}
          defaultValue={data.meta_schema}
          multiline
          minRows={3}
          maxRows={18}
        />
         <TextField
          id="outlined-basics"
          label="Schema 2"
          variant={"outlined"}
          fullWidth
          name="meta_schema_2"
          onChange={(e) => setschema2(e.target.value)}
          value={schema2}
          defaultValue={data.meta_schema_2}
          multiline
          minRows={3}
          maxRows={18}
        />

        <Button variant="outlined" type="submit">
          Güncelle
        </Button>
      </Box>
      <Box
        component="form"
        method="post"
        
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
      >
       
        <Button variant="outlined" onClick={handleClickOpen} color="error" style={{
          
        }}>
          Sil
        </Button>
        <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL+"healthdelete.php"}
      >
         <input type={"hidden"} name="health_id" value={data.health_id} />
        <DialogTitle id="alert-dialog-title">
          {"Silmek İstediğinize Emin Misiniz?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bu işleme onay verdiğinizde, seçili öğeler kalıcı olarak silinir ve
            hiçbir şekilde geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>İptal</Button>
          <Button onClick={handleClose} autoFocus color="error" type="submit">
            Onayla
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
    </>
  );
};

export default HealtUpdate;
